import RouteContainer from "../../common/styles/RouteContainer"
import RowSpacer from "../../common/styles/RowSpacer"
import booksitoutIcon from '../../config/BooksitoutIcon';
import RouteTitle from "../../common/RouteTitle/RouteTitle"
import CommunityRouteTipsCard from "./CommunityRouteTipsCard"
import RouteTitleConfig from "../../config/RouteTitleConfig";
import PopularBooksBooksitoutCard from "./PopularBooksBooksitoutCard";
import useHtmlTitle from "../../common/useHtmlTitle";
import BookRecommendersCard from "./book-recommendations/BookRecommendersCard";
import UserBookRecommendationCard from "./book-recommendations/user/UserBookRecommendationCard";

const CommunityRoute = () => {
    useHtmlTitle('커뮤니티')

    return (
        <RouteContainer>
            <RouteTitle
				icon={<booksitoutIcon.community />}
                title={'커뮤니티'}
				subTitle={'책에 관한 다양한 소식과 사람들을 알아갈 수 있어요'}
				currentKey={''}
				buttons={RouteTitleConfig.Community}
				rightUi={undefined}
			/>
            <RowSpacer/>

            <BookRecommendersCard/>
            <RowSpacer size={40}/>

            <UserBookRecommendationCard/>
            <RowSpacer size={40}/>

            <PopularBooksBooksitoutCard/>
            <RowSpacer size={40} />

            <CommunityRouteTipsCard />
            <RowSpacer size={40} />
        </RouteContainer>
    )
}

export default CommunityRoute